var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"elementRef",class:this.props.className,style:(this.props.style),on:{"click":_vm.clickHandle}},[(_vm.libraryType == 0)?_c('Icon',{attrs:{"type":_vm.iconType,"size":this.props.size,"color":this.props.color}}):_vm._e(),_vm._v(" "),(_vm.libraryType == 1)?_c('i',{class:_vm.iconType}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5f4fc18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/IconComponent.vue
// module id = null
// module chunks = 